import _ from 'lodash'
import OverlayView from './OverlayView'

export default class CustomMarker {

    constructor(){
        this._overlayView = null
        this._position = null
        this._map = null
    }

    getMap(){
        return this._map
    }

    setMap(map){
        this._map = map
    }

    async setVisible(visible = true){
        if(!this._overlayView) return
        await this._overlayView.setVisible(visible)
    }

    async setLabel(label,color="#000000"){
        if(!this._overlayView) return
        await this._overlayView.setLabel(label,color)
    }

    setColor(color){
        if(!this._overlayView) return
        this._overlayView.setColor(color)
    }

    setAvatar(avatarImg){
        if(!this._overlayView) return
        this._overlayView.setAvatar(avatarImg)
    }

    getPosition(){
        return this._position
    }

    async setPosition(...args){
        if(args.length === 1)
            this._position = args[0]
        else {
            this._position = new google.maps.LatLng(
                args[0],
                args[1]
            )
        }
        if(!this._overlayView){
            this._overlayView = new OverlayView(this._map,this._position)
            this._overlayView.setToPosition(this._position)
            return
        }
        this._overlayView.animateToPosition(this._position.lat(), this._position.lng())
    }

}